import { Suspense } from "react";
import { useIntl } from "react-intl";

import Suspender from "lib/Suspender";

import { LoadingSkeleton } from "@joor/design-system";
import { asMaybeNumber } from "lib/conversions";
import { WorkspaceFinancialsPriceLevelFragment } from "operations";
import { StyledContent, StyledLabel, StyledTitle } from "./styledComponents";

type PriceLevel = Omit<WorkspaceFinancialsPriceLevelFragment, "id">;

type Props = {
  loading: boolean;
  rollup: PriceLevel[] | undefined;
  moreCurrencies: boolean;
};
export const ExtendedCost = (props: Props) => {
  const intl = useIntl();

  const listExtendedCost =
    props.rollup &&
    props.rollup.map((pl) => {
      const parsedCost = asMaybeNumber(pl.extCost);
      const parsedCurrency = pl.currencyCode;
      return (
        <StyledTitle data-testid="ext-cost-value">
          {parsedCost !== undefined && parsedCurrency !== undefined
            ? intl.formatNumber(parsedCost, {
                style: "currency",
                currency: parsedCurrency,
              })
            : "-"}
        </StyledTitle>
      );
    });

  const extendedCost =
    props?.rollup && props.rollup[0]
      ? asMaybeNumber(props.rollup[0].extCost)
      : 0;
  const currencyCode =
    props.rollup && props.rollup[0] && props.rollup[0].currencyCode;

  return (
    <StyledContent>
      <StyledLabel>Final Ext. Cost</StyledLabel>
      <Suspense fallback={<LoadingSkeleton />}>
        <Suspender suspend={props.loading}>
          {props.moreCurrencies ? (
            listExtendedCost
          ) : (
            <StyledTitle data-testid="ext-cost-value">
              {extendedCost !== undefined && currencyCode !== undefined
                ? intl.formatNumber(extendedCost, {
                    style: "currency",
                    currency: currencyCode,
                  })
                : "-"}
            </StyledTitle>
          )}
        </Suspender>
      </Suspense>
    </StyledContent>
  );
};
